import { IOfferSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { isFromBuilder } from '../agent';

export const getCallButtonText = (offer: IOfferSchema): string => {
  return isFromBuilder(offer) ? 'Контакты застройщика' : 'Контакты представителя';
};
